const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/EmptyState/EmptyState.tsx';
import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';

import * as Styles from './styles';
import textMap from './translations';
import React from 'react';
import GoBackToDashboardButton from 'App/pages/GoBackToDashboardButton';

export interface IEmptyStateProps {
    intlText: any;
}

export const EmptyState = (props: IEmptyStateProps) => {
    const { intlText } = props;

    return (
        <>
            <GoBackToDashboardButton />
            <div className={Styles.rootStyle}>
                <Typography sx={{ color: 'text.secondary' }} variant="h5" component="div">
                    {!!intlText && <FormattedMessage {...intlText} />}
                    {!intlText && <FormattedMessage {...textMap.unknownKind} />}
                </Typography>
            </div>
        </>
    );
};
